import React from "react";
import {
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { SCREENING_QUESTION_TEMPLATES } from "../../constants/screeningQuestionTemplates";
import { EditingIcon } from "../../Icons/Editing-Icon";
import "./ScreeningQuestionCard.css";

const DeleteIcon = `${process.env.PUBLIC_URL}/assests/img/deleteicon.svg`;

const ScreeningQuestionCard = ({
  question,
  onRemove,
  onChange,
  onSave,
  onCancel,
  onEdit,
  isSaved = false,
}) => {
  const template = SCREENING_QUESTION_TEMPLATES.find(
    (t) => t.id === question.templateId,
  );

  if (!template) return null;

  const placeholderValues = question.placeholderValues || {};
  const isEditing = question.isEdit === true;

  const getDisplayQuestion = () => {
    let text = template.questionTemplate;
    template.placeholders.forEach((p) => {
      const val = placeholderValues[p.key]?.trim();
      text = text.replace(`[${p.key}]`, val || `[${p.key}]`);
    });
    return text;
  };

  const handlePlaceholderChange = (key, value) => {
    onChange({
      ...question,
      placeholderValues: { ...placeholderValues, [key]: value },
    });
  };


  return (
    <div className={`sq-card ${isSaved && !isEditing ? "sq-card-saved" : ""}`}>
      <div className="sq-card-header">
        <span className="sq-card-question-text">
          {getDisplayQuestion()}
        </span>
        {isEditing && (
          <IconButton
            size="small"
            onClick={onRemove}
            className="sq-card-close-btn"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </div>

      {/* Placeholder input fields */}
      <div className="sq-card-body">
        {template.placeholders.map((p) => (
          <div key={p.key} className="sq-card-field-group sq-card-field-group-placeholder">
            <label className="sq-card-field-label">{p.label}*</label>
            <TextField
              value={placeholderValues[p.key] || ""}
              onChange={(e) =>
                handlePlaceholderChange(p.key, e.target.value)
              }
              placeholder={p.label}
              size="small"
              variant="outlined"
              className="sq-card-input"
              disabled={!isEditing}
            />
          </div>
        ))}

      </div>

      <div className="sq-card-actions">
        {isEditing ? (
          <>
            <Button
              className="buttonHover"
              size="small"
              variant="contained"
              style={{
                backgroundColor: "var(--primary-bg-color)",
                color: "var(--primary-background-text-color)",
                borderRadius: "10px",
                width: "6rem",
                fontSize: "14px",
              }}
              onClick={onSave}
            >
              Save
            </Button>
          </>
        ) : (
          <>
            <img
              src={DeleteIcon}
              alt="delete icon"
              className="vendor-icon delete-icon"
              onClick={onRemove}
              style={{ cursor: "pointer" }}
            />
            <div
              onClick={onEdit}
              style={{ display: "inline-block", cursor: "pointer" }}
            >
              <EditingIcon />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ScreeningQuestionCard;
